import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import * as R from 'ramda';

import Title from 'components/Title';
import Field from 'components/Field';
import FieldPassword from 'components/FieldPassword';
import Checkbox from 'components/Checkbox';
import Link from 'components/Link';
import Button from 'components/Button';
import Message from 'components/Message';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import Subscription from 'components/Subscription';

import styles from './Login.module.css';

const cx = classNames.bind(styles);

const width = window.outerWidth || window.innerWidth;
const isMobile = width <= 600;

export default class PublicLogin extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    error: PropTypes.string,
    submitting: PropTypes.bool,
    valid: PropTypes.bool,
    isActivating: PropTypes.bool,
    onSubmit: PropTypes.func,
    onHideModal: PropTypes.func,
    onSubmitModal: PropTypes.func,
    onActivateUser: PropTypes.func,
  }

  static defaultProps = {
    children: undefined,
    error: undefined,
    submitting: false,
    valid: false,
    isActivating: false,
    onSubmit: () => {},
    onHideModal: () => {},
    onSubmitModal: () => {},
    onActivateUser: () => {},
  }

  renderErrorModal(error = {}) {
    return (
      <Modal
        ariaHideApp={false}
        contentLabel='Ошибка'
        isOpen={!R.isEmpty(error)}
        onRequestClose={this.props.onHideModal}
      >
        <Subscription
          submitBtn={error.submitBtn}
          activateBtn={error.activateBtn}
          cancelBtn='Закрыть'
          onSubmit={this.props.onSubmitModal}
          onCancel={this.props.onHideModal}
          onActivate={this.props.onActivateUser}
          textError={error.textError}
          isActivating={this.props.isActivating}
        >
          <>
            {error.text}
          </>
        </Subscription>
      </Modal>
    );
  }

  render() {
    const { error, valid, submitting, registration } = this.props;

    return (
      <div className={cx('login')}>
        <div className={cx('login_logo')}>
          <Icon
            icon='logo-login-mobile'
            width={64}
            height={64}
          >
          </Icon>
        </div>
        <Title isRegistration={isMobile}>
          {isMobile ? 'Пожалуйста, введите почту и пароль' : 'Вход'}
        </Title>

        <form
          className={cx('form')}
          onSubmit={this.props.onSubmit}
        >
          <div className={cx('field', {field_login: isMobile})}>
            <Field
              name='email'
              label='Эл. почта'
              center={!isMobile}
              parse={value => value ? value.trim() : value}
              isRegistration={isMobile}
            />
          </div>
          <div className={cx('field')}>
            <FieldPassword
              name='password'
              label='Пароль'
              center={!isMobile}
              parse={value => value ? value.trim() : value}
              isRegistration={isMobile}
            />
          </div>
          {!isMobile &&
            <div className={cx('form-footer')}>
              <Checkbox
                id='remember'
                name='remember'
                theme='bright'
              >
                Запомнить меня
              </Checkbox>
              <div className={cx('restore')}>
                <Link to={this.props.recoveryLink} color='blue' hover='sapphirine'>
                  Восстановить пароль
                </Link>
              </div>
            </div>
          }
          {error && typeof error === 'string' && !isMobile &&
            <div className={cx('message')}>
              <Message text={error} />
            </div>
          }
          <div className={cx('submit')}>
            <Button
              disabled={!valid || submitting}
              isLoading={submitting}
              type='submit'
              block
              upper={!isMobile}
              bordered
              isRe
              customClass={isMobile && 'button--registration'}
            >
              Войти
            </Button>
          </div>
        </form>

        {registration &&
          <div className={cx('register')}>
            <Link color='blue' hover={!isMobile && 'sapphirine'} large bold {...registration} isLoginMobile={isMobile}>
              Регистрация
              {!isMobile &&
                <span className={cx('signupIcon')}>
                  <Icon icon='signup' />
                </span>
              }
            </Link>
            {isMobile &&
              <div className={cx('restore')}>
                <Link to={this.props.recoveryLink} color='blue' hover={!isMobile && 'sapphirine'} isLoginMobile={isMobile}>
                  Забыли пароль?
                </Link>
              </div>
            }
          </div>
        }

        {error && typeof error === 'string' && isMobile &&
          <div className={cx('message')}>
            <Message text={error} />
          </div>
        }

        {this.renderErrorModal(typeof error === 'object' ? error : undefined)}
        {this.props.children}
      </div>
    );
  }
}
